import React from "react";

const BookInputHeader = ({ title }) => {
  return (
    <p className="font-semibold px-4 sm:px-5 py-2 sm:py-3 mb-3 bg-[#FEF6F6] border rounded-md border-[#B5AAAA] max-sm:text-xs">
      {title}
    </p>
  );
};

export default BookInputHeader;
